<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App',
        // metaInfo()  {
        //     return {
        //         // if no subcomponents specify a metaInfo.title, this title will be used
        //         title: this.dataPage.business_name,
        //         // all titles will be injected into this template
        //         titleTemplate: '%s | Paiement marchand'
        //     }
        // },
        data: () => ({}),
        watch: {
            // '$route' (to) {
            // 	document.title = to.meta.title || 'Page de paiement'
            // }
        }
    };
</script>
